import { indexBy } from "@/util/array"
import { applicationState, sessionState } from "@/state"

export default {
    namespaced: true,

    state: () => {
        return {
            fields: [],
            fieldGroupRules: [],
            fieldCache: {}
        }
    },

    getters: {
        cachedFields: state => (providerKey, applyMode) => {
            return state.fieldCache[buildKey(providerKey, applyMode)]
        }
    },

    mutations: {
        updateFields(state, fields) {
            if (Array.isArray(fields[0]?.rules)) {
                fields = fields.map(field => {
                    const newField = { ...field }
                    newField.rules = indexBy(field.rules, "id")
                    return newField
                })
            }

            const cacheKey = buildKey(sessionState.providerKey, applicationState.applyMode)
            state.fieldCache[cacheKey] = fields
            state.fields = fields
        },

        updateFieldGroupRules(state, rules) {
            state.fieldGroupRules = rules
        }
    },
}

function buildKey(providerKey, applyMode) {
    return `${providerKey}:${applyMode}`
}
